"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderRoute = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var LazyRoute_1 = require("./LazyRoute");
var PrivateRoute_1 = require("./PrivateRoute");
function renderRoute(_a) {
    var privateRoute = _a.privateRoute, component = _a.component, routeProps = tslib_1.__rest(_a, ["privateRoute", "component"]);
    var key = (routeProps.exact ? 'exact' : 'non-exact') + "-" + routeProps.path + "-" + (privateRoute ? 'private' : 'public') + "-" + component.name;
    if (privateRoute) {
        return react_1.default.createElement(PrivateRoute_1.PrivateRoute, tslib_1.__assign({ key: key, component: component }, routeProps));
    }
    return react_1.default.createElement(LazyRoute_1.LazyRoute, tslib_1.__assign({ key: key, component: component }, routeProps));
}
exports.renderRoute = renderRoute;
//# sourceMappingURL=Route.js.map